import { render } from "./doughnut.vue?vue&type=template&id=3fc1420f&scoped=true"
import script from "./doughnut.vue?vue&type=script&lang=js"
export * from "./doughnut.vue?vue&type=script&lang=js"

import "./doughnut.vue?vue&type=style&index=0&id=3fc1420f&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src384613071/src/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc1420f"]])

export default __exports__